import { render } from "./Datagrid.vue?vue&type=template&id=68afa066&scoped=true"
import script from "./Datagrid.vue?vue&type=script&lang=js"
export * from "./Datagrid.vue?vue&type=script&lang=js"

import "./Datagrid.vue?vue&type=style&index=0&id=68afa066&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68afa066"]])

export default __exports__